import React from 'react';
import { useTranslation } from 'react-i18next';

/** Sélecteur compact FR / EN (persisté via i18next-browser-languagedetector). */
const LanguageSwitcher = ({ className = '', variant = 'default' }) => {
  const { t, i18n } = useTranslation('common');
  const lng = (i18n.resolvedLanguage || i18n.language || 'fr').split('-')[0];
  const pill =
    variant === 'dark'
      ? 'rounded-full border border-white/[0.14] bg-white/[0.04] p-px shadow-inner'
      : 'rounded-full border border-slate-200/90 bg-slate-100/70 p-px shadow-inner';

  const btn = (code, label) => (
    <button
      type="button"
      key={code}
      onClick={() => i18n.changeLanguage(code)}
      className={`min-h-[30px] min-w-[2.25rem] rounded-full px-2.5 text-[11px] font-semibold tracking-wide transition-colors duration-200 ${
        lng === code
          ? variant === 'dark'
            ? 'bg-white/[0.14] text-white'
            : 'bg-white/95 text-slate-800 shadow-sm ring-1 ring-slate-200/60'
          : variant === 'dark'
            ? 'text-white/45 hover:bg-white/[0.07] hover:text-white/85'
            : 'text-slate-500 hover:bg-white/50 hover:text-slate-800'
      }`}
      aria-pressed={lng === code}
      aria-label={label}
    >
      {code.toUpperCase()}
    </button>
  );

  return (
    <div
      className={`inline-flex items-center gap-0.5 ${pill} ${className}`}
      role="group"
      aria-label={t('lang.switch')}
    >
      {btn('fr', t('lang.fr'))}
      {btn('en', t('lang.en'))}
    </div>
  );
};

export default LanguageSwitcher;
